// import React from 'react';
// import { Select } from 'antd';
// import 'antd/dist/reset.css'; 
// const { Option } = Select;


// const CustomHeader = (props) => {
//   const handleDropdownChange = (value) => {
//     console.log('Selected value:', value);
//   };

//   return (
//     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//       <span>{props.displayName}</span>
//       <Select
//         defaultValue="Option1"
//         style={{ width: 120 }}
//         onChange={handleDropdownChange}
//       >
//         <Option value="Option1">Option 1</Option>
//         <Option value="Option2">Option 2</Option>
//         <Option value="Option3">Option 3</Option>
//       </Select>
//     </div>
//   );
// };

// export default CustomHeader;

// import React, { useState } from 'react';
// import { Select, Checkbox } from 'antd';
// import { FilterOutlined } from '@ant-design/icons';
// import 'antd/dist/reset.css'; 

// const { Option } = Select;

// const CustomHeader = (props) => {
//   const [checkedValues, setCheckedValues] = useState(['Option1']);

//   const handleDropdownChange = (value) => {
//     console.log('Selected value:', value);
//   };

//   const handleCheckboxChange = (e, value) => {
//     const updatedCheckedValues = e.target.checked 
//       ? [...checkedValues, value] 
//       : checkedValues.filter(v => v !== value);
//     setCheckedValues(updatedCheckedValues);
//     console.log('Checked values:', updatedCheckedValues);
//   };

//   const checkboxOptions = [
//     { label: 'Option 1', value: 'Option1' },
//     { label: 'Option 2', value: 'Option2' },
//     { label: 'Option 3', value: 'Option3' }
//   ];

//   return (
//     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//       <span>{props.displayName}</span>
//       <Select
//         defaultValue={checkboxOptions[0].value}
//         style={{ width: 250 }}
//         onChange={handleDropdownChange}
//         dropdownRender={(menu) => (
//           <div>
//             {checkboxOptions.map(option => (
//               <div key={option.value} style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
//                 <Checkbox 
//                   checked={checkedValues.includes(option.value)}
//                   onChange={(e) => handleCheckboxChange(e, option.value)}
//                   style={{ marginRight: 8 }}
//                 />
//                 <span>{option.label}</span>
//               </div>
//             ))}
//             {menu}
//           </div>
//         )}
//       >
//         <FilterOutlined style={{ fontSize: '16px' }} />
//       </Select>
//     </div>
//   );
// };

// export default CustomHeader;


import React, { useState } from 'react';
import { Dropdown, Menu, Checkbox } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css'; 

const CustomHeader = (props) => {
  const [checkedValues, setCheckedValues] = useState(['Option1']);

  const handleCheckboxChange = (e, value) => {
    const updatedCheckedValues = e.target.checked 
      ? [...checkedValues, value] 
      : checkedValues.filter(v => v !== value);
    setCheckedValues(updatedCheckedValues);
    console.log('Checked values:', updatedCheckedValues);
  };

  const checkboxOptions = [
    { label: 'Option 1', value: 'Option1' },
    { label: 'Option 2', value: 'Option2' },
    { label: 'Option 3', value: 'Option3' }
  ];

  // Create menu items with checkboxes
  const menu = (
    <Menu>
      {checkboxOptions.map(option => (
        <Menu.Item key={option.value}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox 
              checked={checkedValues.includes(option.value)}
              onChange={(e) => handleCheckboxChange(e, option.value)}
              style={{ marginRight: 8 }}
            />
            <span>{option.label}</span>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: "fixed"}}>
      <span>{props.displayName}</span>
      <Dropdown overlay={menu} trigger={['click']}>
        <FilterOutlined style={{ fontSize: '16px', cursor: 'pointer', marginLeft: "200px" }} />
      </Dropdown>
    </div>
  );
};

export default CustomHeader;
